/** Brand primary — matches tailwind.config.js `primary` (recharts does not read CSS vars). */
export const PRIMARY_HEX = '#0F8A8A';
